import { createApiCallActions } from 'src/app/common/store/generic.actions';
import { PageResult } from '../../types';
import {
  CurrentUserModel,
  User,
  UserConnectionHistory,
  UserDetailModel,
} from './type';
import { Action } from '../view/types';

export const userActions = {
  getById: createApiCallActions<UserDetailModel>('user', 'getById'),
  add: createApiCallActions<User>('user', 'add'),
  update: createApiCallActions<User>('user', 'update'),
  lockout: createApiCallActions<boolean>('user', 'lockout'),
  getCurrentUser: createApiCallActions<CurrentUserModel>(
    'currentUser',
    'getCurrentUser',
  ),
  getConnectionHistoriesById: createApiCallActions<UserConnectionHistory[]>(
    'user',
    'getConnectionHistoriesById',
  ),
  getMainSalesTeamById: createApiCallActions<number | undefined>(
    'user',
    'getMainSalesTeamById',
  ),
  getStatusActions: createApiCallActions<Action[]>('user', 'getActions'),
};
export type UserAction = typeof userActions;
